import CharmInfo from '../schema/CharmInfo';
import CharmsInfoSchema from '../schema/CharmsInfoSchema';
import charmsInfoStore from '../store';
import { select } from 'satcheljs/lib/legacy';

export interface GetCalendarCharmsInfo {
    charmStore: CharmsInfoSchema;
}

export let getCharmForIdFromStore = select({
    charmStore: () => charmsInfoStore,
})(function getCharmForIdFromStore(charmId: number, state?: GetCalendarCharmsInfo): CharmInfo {
    var store = state.charmStore;
    if (charmId == null || store == null || store.charmInfoMap == null) {
        return null;
    }

    let charmInfoToReturn = store.charmInfoMap.get(charmId.toString());
    if (charmInfoToReturn != null && charmInfoToReturn.IconId == charmId) {
        return charmInfoToReturn;
    }

    return null;
});

export default getCharmForIdFromStore;
